import { useEffect } from 'react';
import i18n from '../src/i18n';
import { useIframeRenderData } from '../contexts/IframeRenderDataContext';

interface LanguageRenderData {
  language?: string;
}

export function useLanguageSync() {
  const renderData = useIframeRenderData<LanguageRenderData>();

  useEffect(() => {
    const tag = renderData?.language;
    if (!tag) return;

    const base = tag.toLowerCase();
    const supported = Object.keys(i18n.options.resources ?? {});
    const lng = supported.includes(base) ? base : base.split('-')[0];

    void i18n.changeLanguage(lng);
  }, [renderData?.language]);
}
